var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H9.986C9.75866 15.3 9.58564 15.6385 9.47564 16H4C2.89543 16 2 15.1046 2 14V4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V9.23205C15.6742 9.37179 15.369 9.57466 15.103 9.84065L15 9.94363V4C15 3.44772 14.5523 3 14 3H4C3.44772 3 3 3.44772 3 4V14C3 14.5523 3.44772 15 4 15ZM12 5.5C12 5.22386 12.2239 5 12.5 5C12.7761 5 13 5.22386 13 5.5V11.9436L12.1194 12.8243C12.0449 12.737 12 12.6237 12 12.5V5.5ZM5 7.5C5 7.22386 5.22386 7 5.5 7C5.77614 7 6 7.22386 6 7.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V7.5ZM9 9C8.72386 9 8.5 9.22386 8.5 9.5V12.5C8.5 12.7761 8.72386 13 9 13C9.27614 13 9.5 12.7761 9.5 12.5V9.5C9.5 9.22386 9.27614 9 9 9ZM10.9807 15.3772L15.8102 10.5478C16.5405 9.81741 17.7246 9.81741 18.455 10.5478C19.1853 11.2781 19.1853 12.4622 18.455 13.1926L13.6256 18.022C13.344 18.3036 12.9912 18.5033 12.6048 18.5999L11.1069 18.9744C10.4555 19.1372 9.86549 18.5472 10.0283 17.8958L10.4028 16.3979C10.4994 16.0116 10.6992 15.6588 10.9807 15.3772Z",
    fill: "#2E5CF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartOptions);
export default __webpack_public_path__ + "static/media/chart-options.f3ef64c1.svg";
export { ForwardRef as ReactComponent };